import { render } from "./TenantApplications.vue?vue&type=template&id=68ff7a09&scoped=true"
import script from "./TenantApplications.vue?vue&type=script&lang=js"
export * from "./TenantApplications.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ff7a09"]])

export default __exports__